import { BlockTracking, Program, ScreenSizesType, Series } from 'frontend/types';
import { detectScreenSize } from 'frontend/utils/helpers';
import InfiniteScroll from 'react-infinite-scroller';
import NoSearchResults from '../NoSearchResults/NoSearchResults';
import PlaceholderCard from './PlaceholderCard/PlaceholderCard';
import { EdithCardLayout } from 'backend/services/types/edithService.types';
import CardList from 'components/CardList/CardList';
interface ResultsListProps {
  hasNextPage: boolean;
  showPlaceholders: boolean;
  loadNextPage?: () => void;
  products: (Program | Series)[];
  blockTracking: BlockTracking;
  hideMetaData?: boolean;
  cardLayout?: EdithCardLayout;
  maxFourCardsInARow?: boolean;
}
const ONE_CARD_PER_ROW = 1;
const TWO_CARDS_PER_ROW = 2;
const THREE_CARDS_PER_ROW = 3;
const TOTAL_NUMBER_CARDS = 20;
const MOBILE_CARD_HEIGHT = 200;
const TABLET_CARD_HEIGHT = 340;
const DESKTOP_CARD_HEIGHT = 300;
const DEFAULT_OFFSET = 200;
export const handleThreshold = (screenSize: ScreenSizesType) => {
  if (screenSize?.isMobile) return MOBILE_CARD_HEIGHT * (TOTAL_NUMBER_CARDS / ONE_CARD_PER_ROW) + DEFAULT_OFFSET;
  if (screenSize?.isPhabletAndLarger && !screenSize?.isTabletPortraitAndLarger) {
    return TABLET_CARD_HEIGHT * (TOTAL_NUMBER_CARDS / TWO_CARDS_PER_ROW) + DEFAULT_OFFSET;
  }
  return DESKTOP_CARD_HEIGHT * (TOTAL_NUMBER_CARDS / THREE_CARDS_PER_ROW) + DEFAULT_OFFSET;
};
const ResultsList = ({
  hasNextPage,
  showPlaceholders,
  loadNextPage,
  blockTracking,
  products,
  hideMetaData,
  maxFourCardsInARow,
  cardLayout = EdithCardLayout.DEFAULT
}: ResultsListProps) => {
  const screenSize = detectScreenSize();
  const threshold = handleThreshold(screenSize);
  const range = (size: number): number[] => [...Array(size)].map((_, i) => i);
  if (showPlaceholders) {
    return <CardList cardLayout={cardLayout} headingLevel={2} hideDescription={Boolean(hideMetaData)} maxFourCardsInARow={maxFourCardsInARow}>
        {range(24).map(p => <PlaceholderCard key={p} />)}
      </CardList>;
  }
  if (products && products.length) {
    return <InfiniteScroll hasMore={hasNextPage} initialLoad={false} loadMore={() => hasNextPage && loadNextPage && loadNextPage()} pageStart={0} threshold={threshold}>
        <CardList headingLevel={2} programs={products} hideDescription={Boolean(hideMetaData)} blockTracking={blockTracking} cardLayout={cardLayout} maxFourCardsInARow={maxFourCardsInARow} />
      </InfiniteScroll>;
  }
  return <NoSearchResults darkTheme data-sentry-element="NoSearchResults" data-sentry-component="ResultsList" data-sentry-source-file="ResultsList.tsx" />;
};
export default ResultsList;